import React from 'react'
import { connect } from 'react-redux'

import Comment from '../../Edit/Comment'

const PRProcessHistory = (props) => {
  return (
    <Comment isEdit={false} accessoriesHeader={props.accessoriesHeader}/>
  )
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PRProcessHistory)